import React from 'react';
import { Construction } from 'lucide-react';

const ComingSoon = ({ sectionName }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-4">
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-4">
        <Construction className="h-10 w-10 text-muted-foreground" />
      </div>
      <h2 className="text-2xl font-semibold text-foreground">
        {sectionName || 'Próximamente'}
      </h2>
      <p className="text-muted-foreground max-w-md">
        Esta sección está en desarrollo. Estará disponible pronto.
      </p>
    </div>
  );
};

export default ComingSoon;

